import * as z$1 from "zod/v4";
//#region src/schemas/common/error-response.ts
const commonErrorSchema = z$1.strictObject({
	code: z$1.string().min(1),
	message: z$1.string().min(1),
	requestId: z$1.string().min(1).optional(),
	details: z$1.unknown().optional()
});
const errorResponseSchema = z$1.strictObject({
	ok: z$1.literal(false),
	error: commonErrorSchema,
	requestId: z$1.string().min(1).optional()
});
//#endregion
export { commonErrorSchema, errorResponseSchema };

//# sourceMappingURL=error-response.js.map